import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  templateEventsViewColumns,
  mapTemplateEventsViewQuery,
} from "./TemplatesEventsView.default";
import { EventTriggerType } from "../repository/data.default";
import { getTemplateEvents, getTemplates } from "../repository/data.repository";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { createSearchRequest } from "../hooks/useSearchRequest";
import { createGridRequest } from "../hooks/useGridRequest";
import { enumRequest } from "../utils/options";

export interface TemplatesEventsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

const templatesRequest = createSearchRequest(getTemplates, "name");

function TemplatesEventsView(props: TemplatesEventsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={templateEventsViewColumns}
      mapQuery={mapTemplateEventsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getTemplateEvents, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              {
                type: "combobox",
                name: "event",
                label: "Event",
                request: enumRequest(EventTriggerType),
              },
              {
                type: "combobox",
                name: "template",
                label: "Template Name",
                request: templatesRequest,
              },
              { type: "togglebox", name: "isActive", label: "Active" },
            ],
          },
        ],
      }}
      actions={() => [
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("TemplatesEvents", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          disabled: !permissions.can("TemplatesEvents", "delete"),
          danger: true,
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default TemplatesEventsView;
